import keyboards from "./keyboards"

const date = "date types"
const number = "number types"
const text = "text types"
export const categories = [date, number, text]

const year = new Date().getFullYear()

export default {
  text: {
    description: "",
    keyboard: keyboards.type.text,
    category: [text],
    minlength: {
      placeholder: 1,
    },
    maxlength: {
      placeholder: 50,
    },
    pattern: {
      placeholder: "",
    },
  },
  search: {
    description: "",
    keyboard: keyboards.type.search,
    category: [text],
    constraints: {
      minlength: {
        placeholder: 1,
      },
      maxlength: {
        placeholder: 50,
      },
      pattern: {
        placeholder: "",
      },
    },
  },
  tel: {
    description: "",
    inputmode: "tel",
    keyboard: keyboards.type.tel,
    constraints: {
      minlength: {
        placeholder: 3,
      },
      maxlength: {
        placeholder: 50,
      },
      pattern: {
        placeholder: "",
      },
    },
  },
  url: {
    description: "",
    keyboard: keyboards.type.url,
    constraints: {
      minlength: {
        placeholder: 3,
      },
      maxlength: {
        placeholder: 50,
      },
      pattern: {
        placeholder: "",
      },
    },
  },

  email: {
    keyboard: keyboards.type.email,
  },

  number: {
    description: "",
    keyboard: keyboards.type.number,
    category: [number],
    constraints: {
      min: {
        placeholder: 1,
      },
      max: {
        placeholder: 100,
      },
      step: {
        placeholder: 10,
      },
    },
  },

  password: {
    keyboard: keyboards.type.password,
    docs:
      "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/password",
    constraints: {
      minlength: {
        placeholder: 5,
      },
      maxlength: {
        pattern: "foo",
        placeholder: 20,
      },

      pattern: {
        placeholder: "",
      },
    },
  },

  date: {
    noInputmode: true,
    keyboard: keyboards.type.date,
    docs:
      "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/date",
    description: "",
    category: [date],
    constraints: {
      min: {
        pattern: "yyyy-mm-dd",
        placeholder: `${year}-04-15`,
      },
      max: {
        pattern: "yyyy-mm-dd",
        placeholder: `${year}-06-01`,
      },
      step: {
        placeholder: "# days to increment",
      },
    },
  },
  time: {
    noInputmode: true,
    keyboard: keyboards.type.time,
    docs:
      "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/time",
    description:
      "<input> elements of type time create input fields designed to let the user easily enter a time (hours and minutes, and optionally seconds).",
    category: [date],
    constraints: {
      min: {
        pattern: "hh:mm:ss",
        placeholder: "06:30:00",
      },
      max: {
        placeholder: "09:45:00",
        pattern: "hh:mm:ss",
      },
      step: {
        placeholder: "1",
      },
    },
  },
  "datetime-local": {
    noInputmode: true,
    keyboard: keyboards.type["datetime-local"],
    docs:
      "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local",
    description: "",
    category: [date],
    constraints: {
      min: {
        pattern: "yyyy-MM-ddThh:mm",
        placeholder: `${year}-01-01T00:00`,
      },
      max: {
        pattern: "yyyy-MM-ddThh:mm",
        placeholder: `${year}-05-28T06:00`,
      },
      step: {
        placeholder: "1",
      },
    },
  },
  month: {
    noInputmode: true,
    keyboard: keyboards.type.month,
    docs:
      "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/month",
    description: "",
    category: [date],
    constraints: {
      min: {
        pattern: "yyyy-MM",
        placeholder: `${year}-03`,
      },
      max: {
        pattern: "yyyy-MM",
        placeholder: `${year}-11`,
      },

      step: {
        placeholder: "# months to increment",
      },
    },
  },
}
